export default "__VITE_ASSET__PVGYhXg4__"